import { Controller } from 'react-hook-form'
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react'
import { PropsValue, Select } from 'chakra-react-select'

import { useEventFormOptions } from '@hooks/useEventFormOptions'

import { MatchEventEditorEventType } from '@common/types'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'
import { useSelectedEventContext } from '@contexts/SelectedEventContext'

import { Option } from '../utils'

export function TeamSelect() {
    const { zodForm, isFormDisabled } = useMatchEditorFormContext()
    const { teams } = useEventFormOptions()
    const { selectedEvent } = useSelectedEventContext()

    const selectedEventType = zodForm.watch('type.value')

    const shouldRenderTeamSelection = Number(selectedEventType) !== MatchEventEditorEventType.fixture_status

    if (!shouldRenderTeamSelection || !teams.length) {
        return null
    }

    return (
        <Controller
            control={zodForm.control}
            name="team_id"
            render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => (
                <FormControl
                    mb={8}
                    isInvalid={!!error}
                    isRequired={shouldRenderTeamSelection}
                    isDisabled={!!selectedEvent || isFormDisabled}>
                    <FormLabel htmlFor="team_id">Select team</FormLabel>
                    <Select
                        id="team_id"
                        name={name}
                        ref={ref}
                        onChange={v => {
                            // reset player fields as current selection, if any, become invalid
                            zodForm.setValue('player1_id', { value: '', label: '' }, { shouldDirty: false })

                            zodForm.setValue('player2_id', { value: '', label: '' }, { shouldDirty: false })

                            onChange(v)
                        }}
                        onBlur={onBlur}
                        value={value as unknown as PropsValue<Option>}
                        placeholder="Select team"
                        options={teams}
                    />
                    <FormErrorMessage>{zodForm.formState.errors.team_id?.message}</FormErrorMessage>
                </FormControl>
            )}
        />
    )
}
